import { createContext, Dispatch, MutableRefObject, ReactNode, SetStateAction, useContext, useState } from 'react';

import { GridApiPro, GridRowSelectionModel, useGridApiRef } from '@mui/x-data-grid-pro';

export type GerarReembolsoContext = {
    fgTodasPromocoes?: boolean;
    setFgTodasPromocoes: Dispatch<SetStateAction<boolean>>;
    hasPromocoes?: boolean;
    setHasPromocoes: Dispatch<SetStateAction<boolean>>;
    selectedPromocoes: GridRowSelectionModel;
    setSelectedPromocoes: Dispatch<SetStateAction<GridRowSelectionModel>>;
    refGrid: MutableRefObject<GridApiPro | null>;
};

interface GerarReembolsoProvider {
    children: ReactNode;
}

const GerarReembolsoContext = createContext<GerarReembolsoContext>({} as GerarReembolsoContext);

export function GerarReembolsoProvider({ children }: GerarReembolsoProvider) {
    const [fgTodasPromocoes, setFgTodasPromocoes] = useState(false);
    const [hasPromocoes, setHasPromocoes] = useState(false);
    const [selectedPromocoes, setSelectedPromocoes] = useState<GridRowSelectionModel>({
        type: 'include',
        ids: new Set(),
    });
    const refGrid = useGridApiRef();

    return (
        <GerarReembolsoContext.Provider
            value={{
                fgTodasPromocoes,
                setFgTodasPromocoes,
                hasPromocoes,
                setHasPromocoes,
                selectedPromocoes,
                setSelectedPromocoes,
                refGrid,
            }}
        >
            {children}
        </GerarReembolsoContext.Provider>
    );
}

export const useGerarReembolsoContext = (): GerarReembolsoContext => useContext(GerarReembolsoContext);
